import {
    DeserializeCallbackFunc,
    DeserializerFunc1,
    IDeserializeContext,
    IPropSchema
} from '@mintdata/mint-kit/impl/util/serializr/src/api/types';
import {_defaultPrimitiveProp} from '../constants';
import {invariant, isAliasedPropSchema, isMapLike, isPropSchema} from '../utils/utils';
import {list} from './list';

/**
 * Similar to list, but map represents a string keyed dynamic collection.
 * This can be both plain objects (default) or ES6 Map like structures.
 * This will be inferred from the initial value of the targetted attribute.
 *
 * @param {*} propSchema
 * @returns
 */
export function map(propSchema):IPropSchema
{
    propSchema = propSchema || _defaultPrimitiveProp;

    invariant(isPropSchema(propSchema), 'expected prop schema as first argument');
    invariant(!isAliasedPropSchema(propSchema), 'provided prop is aliased, please put aliases first');

    return {
        serializer: function(m:Map<string, any> | Object):any
        {
            invariant(m && typeof m === 'object', 'expected object or Map');

            const isMap:boolean = isMapLike(m);
            const result:any = {};

            if( isMap )
                (m as Map<string, any>).forEach(function(value:any, key:string)
                {
                    result[key] = propSchema.serializer(value);
                });
            else
                for( const key in m )
                    result[key] = propSchema.serializer(m[key]);

            return result;
        },
        deserializer: function(jsonObject:any, done:DeserializeCallbackFunc, context:IDeserializeContext, oldValue:any):void
        {
            if( !jsonObject || typeof jsonObject !== 'object' )
                return void done('[serializr] expected JSON object');

            const keys = Object.keys(jsonObject);

            (list(propSchema).deserializer as DeserializerFunc1)(
                keys.map(function(key:string)
                {
                    return jsonObject[key];
                }),
                function(err:any, values:any)
                {
                    if( err )
                        return done(err);

                    const isMap:boolean = isMapLike(oldValue);

                    let newValue;

                    if( isMap )
                    {
                        // if the oldValue is a map, we recycle it
                        // there are many variations and this way we don't have to
                        // know about the original constructor
                        oldValue.clear();
                        newValue = oldValue;
                    }
                    else
                        newValue = {};

                    for( let i = 0, l = keys.length; i < l; i++ )
                        if( isMap )
                            newValue.set(keys[i], values[i]);
                        else
                            newValue[keys[i]] = values[i];

                    done(null, newValue);
                },
                context
            );
        }
    };
}
